import styled from 'styled-components';
import colors from 'constants/colors';

export const SideBarItemContainer = styled.div`
  cursor: pointer;
  height: ${(props) => props.rowHeight ? props.rowHeight + 'px' : '32px'};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  background-color: ${(props) => props.warning? colors.black5: null};
  color: ${(props) => props.warning? colors.red: colors.lightBlue};
  padding-right: 20px;

  .warningCover {
    position: absolute;
    height: 32px;
    left: 100px;
    right: 0;
    background-color: ${colors.black5};
    z-index: 5;
  }
`;

export const TimelineSubHeaderContainer = styled.div`
  position: fixed;
  top: 50px;
  z-index: 500;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: ${colors.black1};
  color: ${colors.white};
  padding-left: 10px;

  .title {
    font-size: 12px;
    letter-spacing: 1px;
    font-weight: 600;
    color: ${colors.silver};
    margin-right: 5px;
  }

  .contentContainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 10px;

    .dateSection {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 170px;
    }
  }
`;

export const ItemRendererContainer = styled.div`
  width: 100%;
  min-width: 0;
  height: 24px;
  line-height: 24px;
  display: block;
  white-space: nowrap;
  text-align: center;
  overflow: hidden;
  text-overflow : ellipsis;
  contain: content; /* Modern containment */
  padding: 0 1.5px;
  font-size: 14px;
  font-weight: bold;
  color: ${colors.black1};
`;

export const GroupLabelContainer = styled.div`
  position: absolute;
  top: ${(props) => props.top ? `${props.top}px` :'0'};;
  background-color: ${colors.black1};
  border-left: 1px solid ${colors.white};
  width: 30px;
  height: ${(props) => props.height ? `${props.height}px` :'32px'};
  display: flex;
  writing-mode: vertical-rl; 
  transform: rotate(180deg);
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: ${colors.white};
  z-index: 100;
`;

export const DividingLine = styled.div`
  position: absolute;
  top: ${(props) => props.top ? `${props.top}px` :'0'};;
  height: 1px;
  width: 100%;
  background-color: ${colors.white};
`;